export * from './delete-standort.component';
export * from './delete-standort.component.module';